/**
 * Shell Entry Point
 *
 * This is the main entry point for the Axium Shell Application.
 * It dynamically imports the bootstrap module to ensure proper
 * initialization order for Module Federation.
 */

import("./bootstrap/bootstrap").catch((error) => {
  // eslint-disable-next-line no-console
  console.error("[Shell] Failed to bootstrap application:", error);
});
